import { Loadable, LoadableOf, mapRecord } from '@schenck/rotec-components';
import { Observable, interval } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { StatisticsApiRequest } from '../../api/model';
import { Injectable } from '@angular/core';
@Injectable()
export class MockDataService {
  getMock$<Data>(url: string, request: StatisticsApiRequest): Observable<LoadableOf<Data>> {
    function removeCompareIfNotRequested(resp: any) {
      if (request.compare) {
        return resp;
      }
      return mapRecord(resp, (entry: any) => {
        entry.compare = undefined;
        return entry;
      });
    }

    return interval(1000).pipe(
      take(1),
      map(() => {
        if (url.endsWith('statistics')) {
          const resp = {
            utilization: { main: 12, compare: 13 },
            operationHours: { main: 3.5, compare: 12.2 },
            balancingCycles: { main: 123123, compare: 123 },
            operationModeOverview: {
              main: {
                7: 640000,
                2: 150000,
                0: 450000,
                6: 50000000,
              },
              compare: {
                7: 25000,
                2: 1400,
                1: 10000,
                6: 50000,
              },
            },
            rotorRanking: {
              xAxisData: [
                'Rotor 1',
                'Rotor 2',
                'Rotor 3',
                'Rotor 4',
                'Rotor 5',
                'Rotor 6',
                'Rotor 7',
                'Rotor 8',
                'Rotor 9',
                'Rotor 10',
                'Rotor 11',
                'Rotor 12',
                'Rotor 13',
              ],
              main: [700, 650, 600, 550, 500, 450, 400, 350, 300, 250, 200, 150, 100],
              compare: [350, 200, 150, 400, 450, 150, 500, 300, 450, 200, 100, 200, 300],
            },
          };
          return removeCompareIfNotRequested(resp);
        }

        if (url.endsWith('production')) {
          const resp = {
            totalCount: {
              main: 1020,
              compare: 800,
            },
            inToleranceCount: {
              main: 473,
              compare: 531,
            },
            notInToleranceCount: {
              main: 547,
              compare: 412,
            },
            averageThroughputTime: {
              main: 12697.522127339615,
              compare: 10426.522127339615,
            },

            accumulatedOutput: {
              unit: 's',
              timestamps: [
                '2020-04-01T06:00:00.000Z',
                '2020-04-01T07:00:00.000Z',
                '2020-04-01T08:00:00.000Z',
                '2020-04-01T09:00:00.000Z',
                '2020-04-01T10:00:00.000Z',
                '2020-04-01T11:00:00.000Z',
                '2020-04-01T12:00:00.000Z',
              ],
              throughputTimes: {
                main: [20, 23, 17, 5, 12, 18, 15, 26, 19],
                compare: [12, 14, 10, 7, 19],
              },
              inToleranceData: {
                main: [500, 400, 600, 700, 450, 500, 320, 670, 487],
                compare: [465, 178, 289, 340, 568],
              },
            },
          };
          return removeCompareIfNotRequested(resp);
        }

        if (url.endsWith('quality')) {
          return {
            unbalanceData: {
              tolerances: [20, 50, 10],
              main: {
                statistics: [],
                data: [
                  {
                    timestamp: '06:00',
                    rotorId: '1234',
                    planes: [
                      {
                        initialAbsolute: 250, // Plane 0 = static
                        residualAbsolute: 40,
                        initialAngle: 34,
                        residualAngle: 270,
                      },
                      {
                        initialAbsolute: 300, // Plane 1 dynamic
                        residualAbsolute: 15,
                        initialAngle: 27,
                        residualAngle: 257,
                      },
                      {
                        initialAbsolute: 150, // Plane 2 dynamic
                        residualAbsolute: 5,
                        initialAngle: 90,
                        residualAngle: 140,
                      },
                    ],
                  },
                  {
                    timestamp: '2020-04-02T09:00:00.000Z',
                    rotorId: 'sdff',
                    planes: [
                      {
                        initialAbsolute: 130, // Plane 0 = static
                        residualAbsolute: 30,
                        initialAngle: 7,
                        residualAngle: 170,
                      },
                      {
                        initialAbsolute: 300, // Plane 1 dynamic
                        residualAbsolute: 80,
                        initialAngle: 65,
                        residualAngle: 264,
                      },
                      {
                        initialAbsolute: 150, // Plane 2 dynamic
                        residualAbsolute: 25,
                        initialAngle: 41,
                        residualAngle: 187,
                      },
                    ],
                  },
                  {
                    timestamp: '2020-04-03T09:00:00.000Z',
                    rotorId: 'asds',
                    planes: [
                      {
                        initialAbsolute: 190, // Plane 0 = static
                        residualAbsolute: 10,
                        initialAngle: 30,
                        residualAngle: 280,
                      },
                      {
                        initialAbsolute: 300, // Plane 1 dynamic
                        residualAbsolute: 36,
                        initialAngle: 42,
                        residualAngle: 187,
                      },
                      {
                        initialAbsolute: 150, // Plane 2 dynamic
                        residualAbsolute: 5,
                        initialAngle: 9,
                        residualAngle: 168,
                      },
                    ],
                  },
                  {
                    timestamp: '2020-04-04T09:00:00.000Z',
                    rotorId: 'tzuzhj',
                    planes: [
                      {
                        initialAbsolute: 140, // Plane 0 = static
                        residualAbsolute: 20,
                        initialAngle: 15,
                        residualAngle: 290,
                      },
                      {
                        initialAbsolute: 300, // Plane 1 dynamic
                        residualAbsolute: 54,
                        initialAngle: 6,
                        residualAngle: 133,
                      },
                      {
                        initialAbsolute: 150, // Plane 2 dynamic
                        residualAbsolute: 5,
                        initialAngle: 31,
                        residualAngle: 189,
                      },
                    ],
                  },
                  {
                    timestamp: '2020-04-05T02:00:00.000Z',
                    rotorId: '564dfg',
                    planes: [
                      {
                        initialAbsolute: 200, // Plane 0 = static
                        residualAbsolute: 20,
                        initialAngle: 18,
                        residualAngle: 247,
                      },
                      {
                        initialAbsolute: 300, // Plane 1 dynamic
                        residualAbsolute: 15,
                        initialAngle: 21,
                        residualAngle: 234,
                      },
                      {
                        initialAbsolute: 150, // Plane 2 dynamic
                        residualAbsolute: 55,
                        initialAngle: 13,
                        residualAngle: 249,
                      },
                    ],
                  },
                  {
                    timestamp: '2020-04-05T09:00:00.000Z',
                    rotorId: '4567',
                    planes: [
                      {
                        initialAbsolute: 180, // Plane 0 = static
                        residualAbsolute: 30,
                        initialAngle: 29,
                        residualAngle: 274,
                      },
                      {
                        initialAbsolute: 320,
                        residualAbsolute: 20,
                        initialAngle: 18,
                        residualAngle: 190,
                      },
                      {
                        initialAbsolute: 230,
                        residualAbsolute: 40,
                        initialAngle: 8,
                        residualAngle: 153,
                      },
                    ],
                  },
                  {
                    timestamp: '2020-04-07T09:00:00.000Z',
                    rotorId: '8912',
                    planes: [
                      {
                        initialAbsolute: 280, // Plane 0 = static
                        residualAbsolute: 45,
                        initialAngle: 17,
                        residualAngle: 214,
                      },
                      {
                        initialAbsolute: 240,
                        residualAbsolute: 18,
                        initialAngle: 16,
                        residualAngle: 213,
                      },
                      {
                        initialAbsolute: 210,
                        residualAbsolute: 35,
                        initialAngle: 15,
                        residualAngle: 212,
                      },
                    ],
                  },
                  {
                    timestamp: '2020-04-07T12:00:00.000Z',
                    rotorId: '3456',
                    planes: [
                      {
                        initialAbsolute: 170, // Plane 0 = static
                        residualAbsolute: 15,
                        initialAngle: 18,
                        residualAngle: 219,
                      },
                      {
                        initialAbsolute: 160,
                        residualAbsolute: 19,
                        initialAngle: 30,
                        residualAngle: 220,
                      },
                      {
                        initialAbsolute: 180,
                        residualAbsolute: 17,
                        initialAngle: 15,
                        residualAngle: 290,
                      },
                    ],
                  },
                ],
              },
              compare: !request.compare
                ? undefined
                : {
                    statistics: [],
                    data: [
                      {
                        timestamp: '2020-04-02T09:00:00.000Z',
                        rotorId: '9876',
                        planes: [
                          {
                            initialAbsolute: 150, // Plane 0 = static
                            residualAbsolute: 25,
                            initialAngle: 15,
                            residualAngle: 290,
                          },
                          {
                            initialAbsolute: 220, // Plane 1 dynamic
                            residualAbsolute: 15,
                            initialAngle: 15,
                            residualAngle: 290,
                          },
                          {
                            initialAbsolute: 150, // Plane 2 dynamic
                            residualAbsolute: 5,
                            initialAngle: 15,
                            residualAngle: 290,
                          },
                        ],
                      },
                      {
                        timestamp: '2020-04-06T09:00:00.000Z',
                        rotorId: '5432',
                        planes: [
                          {
                            initialAbsolute: 220, // Plane 0 = static
                            residualAbsolute: 30,
                            initialAngle: 15,
                            residualAngle: 290,
                          },
                          {
                            initialAbsolute: 240,
                            residualAbsolute: 50,
                            initialAngle: 15,
                            residualAngle: 290,
                          },
                          {
                            initialAbsolute: 170,
                            residualAbsolute: 10,
                            initialAngle: 15,
                            residualAngle: 290,
                          },
                        ],
                      },
                    ],
                  },
            },
            balancingRuns: {
              unit: '%',
              main: [5, 45, 25, 10, 15],
              compare: request.compare ? [70, 15, 40, 30, 10] : undefined,
            },
            nitOutput: {
              unit: '%',
              timestamps: [
                '2020-04-01T01:00:00.000Z',
                '2020-04-01T02:00:00.000Z',
                '2020-04-01T03:00:00.000Z',
                '2020-04-01T04:00:00.000Z',
                '2020-04-01T05:00:00.000Z',
                '2020-04-01T06:00:00.000Z',
                '2020-04-01T07:00:00.000Z',
              ],
              main: [50, 30, 70, 10, 60, 5, 15],
              compare: request.compare ? [70, 15, 40, 30, 10, 20, 50] : undefined,
            },
          };
        }

        if (url.endsWith('condition')) {
          return {
            accumulatedOperationModes: {
              main: {
                7: 640000,
                2: 150000,
                0: 450000,
                6: 50000000,
                1: 20000,
                3: 10000,
                4: 5000,
                5: 30000,
              },
              compare: {
                7: 25000,
                2: 1400,
                1: 10000,
                6: 50000,
              },
            },
            machineEvents: {
              main: {
                events: {
                  data: [
                    { severity: 'Critical', text: 'Operator entered invalid correction radius.' },
                    { severity: 'Major', text: 'Unable to start run, rotor is not secured.' },
                    { severity: 'Minor', text: 'Operator aborted measuring.' },
                    { severity: 'Warning', text: 'Unable to start run, machine is not locked.' },
                    { severity: 'Minor', text: 'Operator aborted measuring.' },
                    { severity: 'Critical', text: 'Operator entered invalid correction radius.' },
                    { severity: 'Warning', text: 'Unable to start run, machine is not locked.' },
                    { severity: 'Major', text: 'Unable to start run, rotor is not secured.' },
                  ],
                  timestamps: [
                    '2020-04-01T09:00:00.000Z',
                    '2020-04-01T10:00:00.000Z',
                    '2020-04-01T11:00:00.000Z',
                    '2020-04-01T12:00:00.000Z',
                    '2020-04-01T13:05:00.000Z',
                    '2020-04-01T14:05:20.000Z',
                    '2020-04-08T09:00:00.000Z',
                    '2020-04-08T12:10:00.000Z',
                    '2020-04-10T09:30:00.000Z',
                    '2020-04-10T12:35:00.000Z',
                    '2020-04-13T09:00:00.000Z',
                    '2020-04-13T12:00:50.000Z',
                  ],
                },
                operationModes: {
                  data: [0, 1, 2, 3, 4, 5, 6, 7],
                  timestamps: [
                    '2020-04-01T01:00:00.000Z',
                    '2020-04-02T02:00:00.000Z',
                    '2020-04-03T03:00:00.000Z',
                    '2020-04-04T04:00:00.000Z',
                    '2020-04-05T05:00:00.000Z',
                    '2020-04-06T06:00:00.000Z',
                    '2020-04-07T07:00:00.000Z',
                    '2020-04-08T08:00:00.000Z',
                  ],
                },
              },
              compare: {
                events: {
                  data: [
                    { severity: 'Critical', text: 'Operator entered invalid correction radius.' },
                    { severity: 'Major', text: 'Unable to start run, rotor is not secured.' },
                    { severity: 'Minor', text: 'Operator aborted measuring.' },
                    { severity: 'Warning', text: 'Unable to start run, machine is not locked.' },
                  ],
                  timestamps: [
                    '2020-04-01T09:00:00.000Z',
                    '2020-04-01T10:00:00.000Z',
                    '2020-04-01T11:00:00.000Z',
                    '2020-04-01T12:00:00.000Z',
                  ],
                },
                operationModes: {
                  data: [5, 1, 7],
                  timestamps: [
                    '2020-04-01T01:00:00.000Z',
                    '2020-04-06T06:00:00.000Z',
                    '2020-04-07T07:00:00.000Z',
                  ],
                },
              },
            },
            machineHealth: {
              main: { condition: 70, availability: 77 },
              compare: request.compare && { condition: 30, availability: 67 },
            },
          };
        }
        return <any>null;
      }),
      map((response) => Loadable.done(response)),
      startWith(Loadable.loading())
    );
  }
}
